var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 51,
    viewBox: "0 0 72 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.069 22.674C47.1771 22.2374 47.4324 21.849 47.7939 21.5711C51.8233 19.2353 54.0886 25.1347 58.8749 23.9746C60.9322 23.4544 62.1368 22.0965 61.9876 20M0 21.0977C0.666247 25.5405 3.45382 30.0249 8.02161 33.6145C17.7168 41.2256 41.5152 46.3967 51.4609 40.3464C52.9346 39.5033 54.2533 38.4254 55.3624 37.1573M30.0824 29.5359C30.1091 28.7538 30.3807 27.9986 30.8605 27.3717C30.8605 27.3717 32.4062 23.959 38.2905 26.118C41.0248 27.122 41.9682 28.4746 41.9362 29.718",
    stroke: "#EAE8DC",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6411 33.802C57.5224 30.182 53.5936 27.1568 50.1427 25.3365C45.0354 22.6474 47.8492 20.6823 47.8492 20.6823C51.8629 18.3655 54.1192 24.2246 58.8868 23.0714C63.6544 21.9182 63.8189 16.0901 53.1424 7.51598C42.4658 -1.05812 17.1255 -3.12149 6.84177 5.67498C-3.44194 14.4715 -1.4351 25.0986 8.21683 32.6694C17.8688 40.2403 41.5792 45.3755 51.4859 39.3612C52.8293 38.6126 54.0409 37.6593 55.0749 36.5376L56.6411 33.802ZM30.8707 26.3242C27.2181 31.7024 37.0824 32.5867 39.3653 31.8834V31.8937C41.9561 31.087 44.4195 27.2499 38.4415 25.052C32.4634 22.8542 30.8707 26.3242 30.8707 26.3242Z",
    fill: "#FFF5BE",
    stroke: "#7D8AD1",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0505 8.09398C47.0505 8.09398 44.881 7.50437 43.618 9.27878C42.3551 11.0532 42.8083 14.8968 47.0505 14.9969C51.2927 15.0971 53.3654 12.7275 51.0177 10.3634C48.67 7.99942 47.0505 8.09398 47.0505 8.09398Z",
    fill: "#FF946E",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0092 6.48233C31.0092 6.48233 30.5354 2.51834 36.3909 3.04887C41.4997 3.51434 40.0423 7.8387 38.8578 8.28415C37.6733 8.7296 31.6323 10.3462 31.0092 6.48233Z",
    fill: "#9FA0A7",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3279 6.05604C17.7587 3.77022 17.3774 2.2745 22.1356 2.01113C26.8938 1.74777 28.2256 6.23493 25.8465 7.20392C23.4674 8.17291 19.3752 8.71455 18.3279 6.05604Z",
    fill: "url(#paint0_linear_0_416)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13135 7.54685C9.13135 7.54685 12.238 5.45698 15.2437 9.44823C18.2494 13.4395 11.4839 16.1668 9.13135 14.5038C6.77882 12.8408 5.83888 10.0026 9.13135 7.54685Z",
    fill: "#00C4B8",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.80272 16.3339C6.80272 16.3339 11.3248 14.8619 12.7008 18.0992C14.0769 21.3365 10.3427 23.3951 8.86679 23.8821C7.39087 24.3691 1.70915 23.4338 3.26829 19.455C3.59107 18.7076 4.07518 18.0403 4.6861 17.5009C5.29702 16.9614 6.01973 16.5629 6.80272 16.3339V16.3339Z",
    fill: "#FF0000",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2695 25.7692C12.2695 25.7692 15.8818 23.7515 18.8874 26.2519C21.8931 28.7522 18.2036 33.3624 14.9828 32.9773C11.7621 32.5922 7.19567 29.3271 12.2695 25.7692Z",
    fill: "#FF652F",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_416",
    x1: 18.6378,
    y1: 3.16929,
    x2: 19.3219,
    y2: 8.3081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#925AED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A473F4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 51,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalette);
export default __webpack_public_path__ + "static/media/palette.355226e24528809f3e40a44aaaa65a6c.svg";
export { ForwardRef as ReactComponent };